import {
  AfterViewInit,
  Component,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { ClaimAdjustmentFilterComponent } from '../claim-adjustment-filter/claim-adjustment-filter.component';
import { UserService } from '../../../../services/user.service';
import { ListService } from '../../../../shared/services/list.service';
import {
  DialogConfig,
  DialogService,
} from '../../../../shared/services/dialog.service';
import { ViewClaimTimesheetsComponent } from '../view-claim-timesheets/view-claim-timesheets.component';
import { ClaimAdjustmentService } from '../../../../services/claim-adjustment.service';
import { NzUploadModule, NzUploadXHRArgs } from 'ng-zorro-antd/upload';

@Component({
  selector: 'ppl-bulk-claim-adjustment',
  standalone: true,
  imports: [
    ButtonComponent,
    ListTableComponent,
    ClaimAdjustmentFilterComponent,
    ViewClaimTimesheetsComponent,
    NzUploadModule,
  ],
  templateUrl: './bulk-claim-adjustment.component.html',
  styleUrl: './bulk-claim-adjustment.component.css',
})
export class BulkClaimAdjustmentComponent implements OnInit, AfterViewInit {
  programName: any;
  bulkClaimData: any;
  batchData: any;
  errorCode: any;
  claimTSData: any;
  type = 'service';
  @ViewChild('batchDetailsDialog')
  batchDetailsDialog!: TemplateRef<any>;
  @ViewChild('claimTimesheetDetailsDialog')
  claimTimesheetDetailsDialog!: TemplateRef<any>;
  @ViewChild(ClaimAdjustmentFilterComponent)
  filterComp!: ClaimAdjustmentFilterComponent;

  @Input() adjustType = 'service';
  private dialogSvc = inject(DialogService);
  fields = [
    { field: 'timeframe', show: true, default: '30 days' },
    { field: 'batchFileTypeLkp', show: true },
  ];
  cols = [
    {
      field: 'batchFileId',
      header: 'File ID',
      jsonpath: 'batchFileId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true,
    },
    {
      field: 'fileName',
      header: 'File Name',
      jsonpath: 'fileName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'totalRecords',
      header: 'Total Records',
      jsonpath: 'totalRecords',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'successRecords',
      header: 'Success Records',
      jsonpath: 'successRecords',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'errorRecords',
      header: 'Error Records',
      jsonpath: 'errorRecords',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'statusLkpDescription',
      header: 'Status',
      jsonpath: 'statusLkpDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'batchFileTypeLkpDesc',
      header: 'File Type',
      jsonpath: 'batchFileTypeLkpDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'createdDate',
      header: 'Created Date',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  batchCols = [
    {
      field: 'runId',
      header: 'Run ID',
      jsonpath: 'runId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'createdDate',
      header: 'Created Date',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'status',
      header: 'Status',
      jsonpath: 'status',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true,
    },
  ];

  constructor(
    private userService: UserService,
    private listService: ListService,
    private claimAdjService: ClaimAdjustmentService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
  }

  ngAfterViewInit() {
    this.filterComp.search();
  }

  addCols(type: any) {
    if (type === 'ClaimServiceAdjustment') {
      this.batchCols = [
        {
          field: 'pplIcn',
          header: 'PPL ICN',
          jsonpath: 'pplIcn',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'runId',
          header: 'Run ID',
          jsonpath: 'runId',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'createdDate',
          header: 'Created Date',
          jsonpath: 'createdDate',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'status',
          header: 'Status',
          jsonpath: 'status',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
          isClickable: true,
        },
        {
          field: 'currentServiceDesc',
          header: 'Service Code',
          jsonpath: 'currentServiceDesc',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'newservicedesc',
          header: 'New Service Code',
          jsonpath: 'newservicedesc',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
      ];
    } else {
      this.batchCols = [
        {
          field: 'pplIcn',
          header: 'PPL ICN',
          jsonpath: 'pplIcn',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'runId',
          header: 'Run ID',
          jsonpath: 'runId',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'createdDate',
          header: 'Created Date',
          jsonpath: 'createdDate',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'status',
          header: 'Status',
          jsonpath: 'status',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
          isClickable: true,
        },
        {
          field: 'currentMcoName',
          header: 'MCO ',
          jsonpath: 'currentMcoName',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'newMcoName',
          header: 'New MCO',
          jsonpath: 'newMcoName',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'currentAuthNumber',
          header: 'Auth',
          jsonpath: 'currentAuthNumber',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'newAuthNumber',
          header: 'New Auth',
          jsonpath: 'newAuthNumber',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
      ];
    }
  }

  onSearch(filters: any) {
    this.searchClaimData(filters);
  }

    onRefresh(filters: any) {
    this.searchClaimData(filters);
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: any,
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchClaimData(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'bulkUploadBatchFile',
      'createdDate',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claimadj')
      .subscribe((data: any) => {
        this.bulkClaimData = data.responsedata;
      });
  }

  getBatchDetails(page: any, fileId: any) {
    const filters: any[] = [
      {
        jsonPath: 'batchFileId',
        value: fileId,
        operator: 'Equal',
      },
    ];
    const processedPayload = this.buildRequestPayload(
      page,
      'createdDate',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claimadj')
      .subscribe((data: any) => {
        this.batchData = data.responsedata;
        this.openBatchDetailsDialog();
      });
  }

  rowActions(event: any) {
    if (event?.col?.field === 'batchFileId') {
      const type = event?.event?.batchFileTypeLkp;
      const pageName =
        type === 'ClaimServiceAdjustment'
          ? 'billingServiceAdjustment'
          : 'billingMCOAdjustment';
      this.getBatchDetails(pageName, event?.event?.batchFileId);
      this.addCols(type);
    }
    if (event?.col?.field === 'status') {
      const claim = event?.event;
      this.errorCode = claim.reason || claim.errCode;
      this.claimTSData = claim?.currentTimesheets?.map(
        (id: number, index: number) => ({
          id: id,
          status: claim.newTimesheets[index],
        })
      );
      this.openClaimTSDetailsDialog();
    }
  }

  openClaimTSDetailsDialog() {
    const dialogConfig: DialogConfig = {
      title: 'Adjustment Details',
      size: 'large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };
    this.dialogSvc.openDialog(
      this.claimTimesheetDetailsDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openBatchDetailsDialog() {
    const dialogConfig: DialogConfig = {
      title: 'Batch Adjustment Details',
      size: 'large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };
    this.dialogSvc.openDialog(
      this.batchDetailsDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {}
  onDownload(type: string) {
    this.claimAdjService.downloadTemplate(this.programName, type);
  }

  onUpload(type: any) {
    this.type = type === 'MCO' ? 'BULK_MCO_ADJUST' : 'BULK_ADJUST';
  }

  customRequest = (item: NzUploadXHRArgs): any => {
    const formData = new FormData();
    formData.append('file', item.file as any);
    const allowedExtensions = ['csv', 'xlsx', 'xls'];
    const fileExtension = item.file.name.split('.').pop()?.toLowerCase();
    if (allowedExtensions.includes(fileExtension || '')) {
      const requestPayload = {
        adjustmentType: this.type,
        programCode: this.programName,
      };

      formData.append(
        'json',
        new Blob([JSON.stringify(requestPayload)], { type: 'application/json' })
      );

      this.claimAdjService.adjustBulkClaims(formData).subscribe({
        next: (response: any) => {
          if (item.onSuccess) {
            item.onSuccess(response, item.file, null);
            this.filterComp.search();
          }
        },
        error: (error: any) => {
          if (item.onError) {
            item.onError(error, item.file);
          }
        },
      });
    } else {
      console.log('incorrect file type');
    }
  };
}
